<template>
    <div class="root" v-loading="loading">
        <div style="height: 1px;"></div>
        <div class="container theme-showcase" v-if="!submitOK" style="max-width: 100% !important;">
            <div style="color: rgb(1 141 253); font-weight: bold; margin:12px 0; font-size: 16px;">亲爱的：{{ nickname }}
            </div>
            <div style="color: gray; font-size: 14px; line-height: 20px; margin-bottom: 15px;">
                您的留言内容将会公开展示在“金园超市意见建议公示台”上，若对此有所顾虑，您可通过“联系我们”直接拨打门店值班电话反馈您的问题~
                <span v-if="wxopenid">~</span>
            </div>
            <el-form :model="form">
                <el-form-item required :error="shopnameErr">
                    <el-input v-model="shopname" readonly placeholder="请选择门店" @focus="showshops"></el-input>
                </el-form-item>
                <el-form-item required :error="phoneErr">
                    <el-input v-model="phone" type="number" placeholder="请输入联系电话" @change="phoneChange"></el-input>
                </el-form-item>
                <el-form-item required :error="contentErr">
                    <el-input v-model="contenttxt" placeholder="请在这里直接填写您的问题或意见建议，谢谢" type="textarea"
                        @change="contentChange" :rows="6"></el-input>
                </el-form-item>
            </el-form>


            <div style="display: flex; align-items:center; margin-bottom: 5px;">
                <div>
                    <el-upload class="avatar-uploader" :class="{ hide: hideUploadBtn }" action="#"
                        :http-request="topimgUpload" :limit="3" list-type="picture-card" accept="image/*"
                        :file-list="fileList" :on-change="handleEditChange" :on-remove="handleRemove"
                        :before-upload="beforeUpload" :before-remove="beforeRemove">
                        <i class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                </div>
            </div>
            <div v-if="imgids.length == 0"
                style="color: gray; font-size: 14px; margin-bottom: 25px; text-align: center; width: 86px;">
                上传照片
            </div>

            <div>
                <el-button type="success" style="width: 100%; background-color: #1aac19;"
                    @click="addSubmit">提交</el-button>
            </div>


            <div v-if="false">
                <el-button type="success" style="width: 100%; background-color: #1aac19;"
                    @click="clearStorge">ssssss</el-button>
            </div>


            <el-dialog title="请选择门店" :visible.sync="dialogTableVisible">
                <div v-for="item in shoplist" :key="item.id" class="divshopitem"
                    @click="selectShop(item.id, item.name)">
                    {{ item.name }}</div>
            </el-dialog>


            <div style="position: fixed; bottom: 0; left: 0; width: 100vw; border-top: 1px #c8c8c8 solid;">
                <div
                    style="max-width: 520px; margin: auto; background-color: #f7f6fb; display: flex; padding: 6px 0; color: gray; font-size: 14px; line-height: 18px;">
                    <div style="flex: 1;text-align: center;" @click="tosug">
                        <div><img style="width:26px;" src="https://jinyuan.daxuxian.com/images/icon/biji2.png" /></div>
                        <div style="text-align: center; color: #1aac19;">提建议</div>
                    </div>
                    <div style="flex: 1;text-align: center;" @click="tosuglist">
                        <div><img style="width:26px;" src="https://jinyuan.daxuxian.com/images/icon/gongshi1.png" />
                        </div>
                        <div style="text-align: center;">意见建议公示台</div>
                    </div>
                    <div style="flex: 1; text-align: center;" @click="tomysug">
                        <div><img style="width:26px;" src="https://jinyuan.daxuxian.com/images/icon/wode1.png" /></div>
                        <div style="">我的建议</div>
                    </div>
                </div>
            </div>

        </div>
        <div v-if="submitOK" style="width: 90%; margin:20px auto; font-size: 18px; line-height: 36px;">
            <div style="margin-bottom: 12px;">
                尊敬的顾客朋友：
            </div>
            <div>
                您好！您的留言我们已收到，我们会按照公司意见建议流程标准落实处理，并尽快给您详细回复。为了更好地在第一时间倾听您的建议和为您解决问题，请您留下详细的信息和准确的联系方式！
            </div>
            <div style="margin: 18px 0;">
                感谢您的留言，祝您生活愉快！
            </div>
            <div style="width: 100%; margin:20px auto;">
                <el-button type="primary" plain style="width:100%" @click="tomysug">关闭</el-button>
            </div>
        </div>
    </div>
</template>

<script>

import axios from 'axios'

export default {
    name: 'PromoCodelist',
    data: function () {
        return {
            form: {},
            amount: '',
            count: "",
            amountErr: '',
            countErr: '',
            preRegNo: '',
            AutoCheckin: false,
            AutoPrint: false,
            id: 0,
            eventId: '',
            eventList: [],
            loading: false,
            dialogFormVisible: false,
            angle: 0,
            x: 0,
            y: 0,
            w: 100,
            h: 100,
            imgUrl: '',
            showDetails: false,
            currentPage: 1,
            list: [],
            total: 0,
            nickname: '',
            dialogTableVisible: false,
            hideUploadBtn: false,
            fileList: [],
            shopname: '',
            shopid: '',
            phone: '',
            contenttxt: '',
            imgids: [],
            shopnameErr: '',
            phoneErr: "",
            contentErr: '',
            shoplist: [],
            wxopenid: '',
            submitOK: false
        }
    },
    components: {

    },
    methods: {
        tosug() {
            this.$router.push('/');
        },
        tosuglist() {
            this.$router.push('/suglist');
        },
        tomysug() {
            this.$router.push('/mysug');
        },
        isValidPhone(phone) {
            const reg = /^1[3-9]\d{9}$/;  // 1开头，第二位3-9，后面9位数字
            return reg.test(phone);
        },
        phoneChange(val) {
            console.log(val);
            if (val != '' && val.length > 0) {
                if (this.isValidPhone(val)) {
                    this.phoneErr = '';
                } else {
                    this.phoneErr = "请输入正确的联系电话";
                }
            }
            else {
                this.phoneErr = "请输入联系电话";
            }
        },
        contentChange(val) {
            console.log(val);
            if (val != '' && val.length > 0) { this.contentErr = ''; }
            else {
                this.contentErr = "请输入联系电话";
            }
        },
        selectShop(id, name) {
            console.log("店铺id：" + id, name);
            this.shopname = name;
            this.shopid = id;
            this.dialogTableVisible = false;
            this.shopnameErr = '';
        },
        loadShop() {
            this.loading = true;
            axios.post('/api/Suggestion/ShopList',
                {
                    skip: 0,
                    limit: 100,
                    token: this.wxtoken,
                    openid: this.openid
                }
            )
                .then(this.loadShopSucc)
        },
        loadShopSucc(res) {
            this.loading = false;
            res = res.data
            console.log(res);
            if (res && res.Code == 200) {
                this.shoplist = res.list;
            } else {
                if (res && res.Code == 301) {
                    localStorage.removeItem('wxopenid');
                    localStorage.removeItem('wxtoken');
                    this.getwxuserinfo();
                }
            }
        },
        beforeUpload() {
            console.log("beforeUpload");
            var openid = localStorage.getItem('wxopenid'); //'oqyAl3Tr7dkiDLv8fcUVVnwahc18';// 
            if (openid && openid != null && openid != undefined) {

            } else {
                this.fileList=[];
                this.getwxuserinfo();
            }
        },
        beforeRemove(file, fileList) {
            console.log(file.uid);
            console.log(fileList);
            var uid = file.uid;
            var index = fileList.findIndex(item => item.uid == uid)
            console.log(index);
            this.imgids.splice(index, 1);
            console.log("此时的id数组：", this.imgids);
        },
        handleRemove(file, fileList) {
            this.hideUploadBtn = fileList.length >= 6;
        },
        handleEditChange(file, fileList) {
            console.log(file, fileList);
            this.hideUploadBtn = fileList.length >= 3;
        },
        topimgUpload(data) {
            var formData = new FormData();
            formData.append("file", data.file);
            var openid = this.wxopenid;
            var token = this.wxtoken;
            console.log(openid);
            console.log(token);

            axios.post('api/UploadFile/WxUpLoadOneImg?openid=' + openid + '&token=' + token + '&type=110',
                formData
            )
                .then(this.topimgUploadSucc)
        },
        topimgUploadSucc(res) {
            res = res.data
            console.log(res);
            if (res && res.Code == 200) {
                var ids = this.imgids;
                console.log(ids);
                console.log(res.fileId);
                this.imgids.push(res.fileId);
                console.log(this.imgids);
                // this.$set(this.form,'topimg',res.fileUrl);
            } else {
                if (res && res.Code == 301) {
                    console.log("验证没通过");
                }
            }
        },
        showshops() {
            console.log("showshops");
            this.dialogTableVisible = true;
        },
        add() {
            this.dialogFormVisible = true;
        },
        addSubmit() {
            console.log("submit");
            var shopname = this.shopname;
            var shopid = this.shopid;
            var contenttxt = this.contenttxt;
            var phone = this.phone;
            var imgIds = this.imgids;
            var openid = localStorage.getItem('wxopenid'); //'oqyAl3Tr7dkiDLv8fcUVVnwahc18';// 
            if (openid && openid != null && openid != undefined) {
                this.openid = openid;
            } else {
                this.getwxuserinfo();
            }
            if (shopname == '') {
                this.shopnameErr = '请选择门店';
            } else {
                this.shopnameErr = '';
            }
            if (phone == '') {
                this.phoneErr = '请输入联系电话';
            } else {
                if (this.isValidPhone(phone)) {
                    this.phoneErr = '';
                } else {
                    this.phoneErr = '请输入正确的联系电话';
                }
            }
            if (contenttxt == '') {
                this.contentErr = '请输入';
            } else {
                this.contentErr = '';
            }
            if (shopname == '' || contenttxt == '' || phone == '') {
                return;
            }
            this.loading = true;
            axios.post('/api/Suggestion/Createsuggestion',
                {
                    ShopId: shopid,
                    Tel: phone,
                    Content: contenttxt,
                    ImgIds: imgIds,
                    token: this.wxtoken,
                    openid: openid
                }
            )
                .then(this.addSucc)
        },
        addSucc(res) {
            this.loading = false;
            res = res.data
            console.log(res);
            if (res && res.Code == 200) {
                this.submitOK = true;
                this.$message({
                    message: '提交成功!',
                    type: 'success',
                    onClose: () => {
                    }
                });
            } else {

            }
        },

        inputChange(res) {
            console.log(res);
            if (res != null && res != undefined && res.length >= 5) {
                // this.loadData();
            }
        },

        goBack() {
            this.$router.back();
        },

        eventChange(id) {
            console.log(id);
            localStorage.setItem('eventId', id);
            this.currentPage = 1;
        },

        getwxuserinfo() {
            this.loading = true;
            axios.get('/api/weixin/GetAuthorizeUrl?st=suggestion')
                .then(this.getwxuserinfoSucc)
        },
        getwxuserinfoSucc(res) {
            this.loading = false;
            res = res.data
            console.log(res);
            if (res && res.success) {
                var url = res.authorizeUrl;
                window.location.href = url;
            } else {

            }
        },
        getUserInfoFromUrl(key) {
            try {
                const urlParams = new URLSearchParams(window.location.search);
                const userInfo = urlParams.get(key);
                return userInfo;
            } catch (err) {
                return '';
            }
        },
        checkwx() {

            const userInfoStr = this.$route.query.userInfo;
            const wxtoken = this.$route.query.wxtoken;
            if (userInfoStr && userInfoStr.length > 0) {
                // localStorage.setItem("wxuserJson", userInfoStr);
                var userInfo = JSON.parse(userInfoStr);
                this.nickname2 = userInfoStr;
                try {

                    localStorage.setItem("wxopenid", userInfo['openid']);
                    localStorage.setItem("wxnickname", userInfo['nickname']);
                    localStorage.setItem("wxtoken", wxtoken);
                    this.wxtoken = wxtoken;
                    this.wxopenid = userInfo['openid'];
                } catch (err) {

                }
            } else {

            }

        },
        clearStorge() {
            localStorage.setItem("wxopenid", '');
        },
    },
    mounted() {
        var errcode = this.$route.query.errcode;
        console.log(errcode);
        if (errcode == 'reject') {
            return;
        } else {
            this.checkwx();
        }

        var openid = localStorage.getItem('wxopenid');
        if (openid && openid != null && openid != undefined) {
            this.openid = openid;
            this.wxopenid = openid;
        } else {
            this.getwxuserinfo();
        }

        var wxnickname = localStorage.getItem("wxnickname");
        if (wxnickname) {
            this.nickname = wxnickname;
        }
        var wxtoken = localStorage.getItem("wxtoken");
        if (wxtoken) {
            this.wxtoken = wxtoken;
        }

        this.loadShop();
        this.submitOK = false;
    },
    beforeDestroy() {

    }
}
</script>
<style scoped>
.mytd {
    border-bottom: 1px #ccc solid;
    border-right: 1px #ccc solid;
    padding: 10px;
    margin: 0;
    box-sizing: border-box;
}

.el-table .warning-row {
    background: oldlace;
}

.el-table .success-row {
    background: #f0f9eb;
}

.root>>>.topmenuitem:nth-child(10) {
    color: #fff;
    background-color: #080808;
}

.root>>>.el-dialog {
    width: 80% !important;
}



.rootdiv>>>.topmenuitem:nth-child(8) {
    color: #fff;
    background-color: #080808;
}

.avatar-uploader>>>.el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-uploader>>>.el-upload:hover {
    border-color: #409EFF;
}

.avatar-uploader>>>.el-upload--picture-card {
    width: 20vw !important;
    height: 20vw !important;
    line-height: 20vw;
}

.avatar-uploader>>>.el-upload-list__item {
    width: 20vw;
    height: 20vw;
}

.avatar-uploader>>>.el-upload {}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 20vw !important;
    height: 20vw !important;
    line-height: 20vw;
    text-align: center;
}

.avatar {
    width: 20vw;
    display: block;
}

.hide {
    .el-upload--picture-card {
        display: none !important;
    }
}

.root>>>.el-dialog__body {
    padding: 1px !important;
}

.root>>>.el-dialog__header {
    padding: 16px 10px 10px 10px;
    border-bottom: 1px #f1f1f1 solid;
}
.root{
    
    max-width: 520px;
    margin: auto;
}

.divshopitem {
    border-bottom: 1px #f1f1f1 solid;
    padding: 12px 15px;
    font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/pages/suggestions/suggestion.vue